import React,{useState} from 'react';
import {motion} from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const {FiLock,FiKey,FiAlertCircle,FiBook}=FiIcons;

const AuthScreen=({onAuthenticated})=> {
const [accessCode,setAccessCode]=useState('');
const [error,setError]=useState('');
const [isLoading,setIsLoading]=useState(false);

// Updated access codes with more random format
const validCodes=[
  'wnq9drxqr3', // New primary code
  'grace8k2p7', // Primary backup
  'wisdom4m9n3', // Secondary backup
  'pen5jqx7v',   // Tertiary backup
  'cross2k8p4',  // Additional backup
  'faith9m3n6',  // Additional backup
  'write4q7x2',  // Additional backup
  'refine8k9p5', // Additional backup
  'release3m7n4', // Additional backup
  'author6q8x3'  // Additional backup
];

const handleSubmit=async (e)=> {
e.preventDefault();
setIsLoading(true);
setError('');

// Simulate authentication delay
await new Promise(resolve=> setTimeout(resolve,1000));

// Check if the code is valid
if (validCodes.includes(accessCode.trim().toLowerCase())) {
onAuthenticated();
} else {
setError('Invalid access code. Please check your code and try again.');
}

setIsLoading(false);
};

return (
<div className="min-h-screen flex items-center justify-center px-4 py-8 bg-gradient-to-br from-slate-50 to-blue-50">
<div className="max-w-md w-full">
<motion.div
initial={{opacity: 0,y: 20}}
animate={{opacity: 1,y: 0}}
transition={{duration: 0.8}}
className="bg-white rounded-2xl shadow-xl p-8"
>
<div className="text-center space-y-6">
{/* Logo/Icon */}
<motion.div
initial={{scale: 0}}
animate={{scale: 1}}
transition={{delay: 0.2,type: "spring",stiffness: 200}}
className="w-20 h-20 bg-primary rounded-2xl flex items-center justify-center mx-auto"
>
<SafeIcon icon={FiLock} className="text-3xl text-white" />
</motion.div>

{/* Title */}
<div className="space-y-2">
<h1 className="text-3xl font-serif text-gray-900">
Course Access
</h1>
<p className="text-gray-600">
Enter your access code to continue to the Write. Refine. Release. Course Tools
</p>
</div>

{/* Form */}
<form onSubmit={handleSubmit} className="space-y-6">
<div>
<label htmlFor="accessCode" className="block text-sm font-medium text-gray-700 mb-2">
Access Code
</label>
<div className="relative">
<div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
<SafeIcon icon={FiKey} className="text-gray-400" />
</div>
<input
type="text"
id="accessCode"
value={accessCode}
onChange={(e)=> setAccessCode(e.target.value)}
placeholder="Enter your course access code"
className="w-full pl-10 pr-3 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent text-center font-mono text-lg"
required
/>
</div>
</div>

{error && (
<motion.div
initial={{opacity: 0,y: -10}}
animate={{opacity: 1,y: 0}}
className="flex items-center gap-2 p-3 bg-red-50 border border-red-200 rounded-lg"
>
<SafeIcon icon={FiAlertCircle} className="text-red-600 flex-shrink-0" />
<span className="text-red-700 text-sm">{error}</span>
</motion.div>
)}

<motion.button
type="submit"
disabled={isLoading || !accessCode.trim()}
whileHover={{scale: 1.02}}
whileTap={{scale: 0.98}}
className="w-full bg-primary hover:bg-blue-700 disabled:bg-gray-300 text-white py-3 rounded-lg font-semibold transition-all duration-300 shadow-lg hover:shadow-xl disabled:shadow-none"
>
{isLoading ? (
<span className="flex items-center justify-center gap-2">
<motion.div
animate={{rotate: 360}}
transition={{duration: 1,repeat: Infinity,ease: "linear"}}
className="w-5 h-5 border-2 border-white border-t-transparent rounded-full"
/>
Verifying...
</span>
) : (
'Access Course Tools'
)}
</motion.button>
</form>

{/* Help Section */}
<motion.div
initial={{opacity: 0}}
animate={{opacity: 1}}
transition={{delay: 0.5}}
className="pt-6 border-t border-gray-200"
>
<div className="flex items-center gap-2 text-sm text-gray-600 mb-3">
<SafeIcon icon={FiBook} className="text-primary" />
<span className="font-medium">Need help?</span>
</div>
<p className="text-xs text-gray-500 leading-relaxed">
This tool suite is exclusive to the <strong>Write. Refine. Release.</strong> workshop participants. 
Check your course materials or contact Jeremy Bouma at GospelWise Author if you need access.
</p>
</motion.div>
</div>
</motion.div>

{/* Branding */}
<motion.div
initial={{opacity: 0}}
animate={{opacity: 1}}
transition={{delay: 0.8}}
className="text-center mt-8 space-y-2"
>
<p className="text-sm text-gray-600">
A companion tool suite for
</p>
<p className="text-lg font-serif text-primary">
Write. Refine. Release.
</p>
<p className="text-xs text-gray-500">
by GospelWise Author
</p>
</motion.div>
</div>
</div>
);
};

export default AuthScreen;